/* Bobblery — <bobblery-sticky-buy>. Reveals the mobile buy bar once the main
   Add to cart button scrolls out of view. The bar's button uses
   form="product-form-…" so it submits the real product form (Dawn AJAX cart). */
if (!customElements.get('bobblery-sticky-buy')) {
  customElements.define(
    'bobblery-sticky-buy',
    class BobbleryStickyBuy extends HTMLElement {
      connectedCallback() {
        const form = document.getElementById(this.dataset.form);
        const mainBtn =
          document.querySelector('.product-form__submit') ||
          (form && form.querySelector('[name="add"]'));

        if (!mainBtn || !('IntersectionObserver' in window)) {
          this.classList.add('is-visible');
          return;
        }

        this._btn = mainBtn;
        this._io = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              this.classList.toggle('is-visible', !entry.isIntersecting);
            });
          },
          { threshold: 0 }
        );
        this._io.observe(mainBtn);
      }

      disconnectedCallback() {
        if (this._io && this._btn) this._io.unobserve(this._btn);
      }
    }
  );
}
